import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import CasinoBallotQuestionReport from '../../../types/reports/casinoBallotQuestionReport';
import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Divider, Paper, Link } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useErrorBoundary } from 'react-error-boundary';

const CasinoBallotQuestionSpending = (): JSX.Element => {
  const [reports, setReports] = useState<CasinoBallotQuestionReport[]>([]);
  const { showBoundary } = useErrorBoundary();

  const getCasinoBallotQuestionSpendingReports = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/reports/casinobqs`)
        .then(result => {
          if (!result.ok) {
            showBoundary(new Error('Failed to get ballot question reports.'));
          }
          return result.json();
        })
        .then(result => {
          setReports(result);
        });
    } catch (error) {
      console.error('Uncaught Error:', error);
    }
  }
  


  // const tempData = [
  //   {
  //     "id": 2093,
  //     "filingEntity": "Mass Gaming & Entertainment, LLC",
  //     "pdfFileName": "gaming2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "6/1/2015",
  //     "startDate": "4/25/2015",
  //     "dateFiled": "June 11, 2015",
  //     "dateFiledShort": "6/11/2015",
  //     "reportingPeriod": "4/25/2015 - 6/1/2015",
  //     "position": "Support",
  //     "city": "Brockton"
  //   },
  //   {
  //     "id": 2094,
  //     "filingEntity": "Mass. Gaming & Entertainment LLC (pre-election amendment)",
  //     "pdfFileName": "gamingamendment2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "4/24/2015",
  //     "startDate": "2/26/2015",
  //     "dateFiled": "June 11, 2015",
  //     "dateFiledShort": "6/11/2015",
  //     "reportingPeriod": "2/26/2015 - 4/24/2015",
  //     "position": "Support",
  //     "city": "Brockton"
  //   },
  //   {
  //     "id": 2095,
  //     "filingEntity": "Adriano Cabral, Brockton",
  //     "pdfFileName": "cabral2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "6/1/2015",
  //     "startDate": "4/25/2015",
  //     "dateFiled": "June 11, 2015",
  //     "dateFiledShort": "6/11/2015",
  //     "reportingPeriod": "4/25/2015 - 6/1/2015",
  //     "position": "Support",
  //     "city": "Brockton"
  //   },
  //   {
  //     "id": 2096,
  //     "filingEntity": "Carney Office Building Trust",
  //     "pdfFileName": "carney2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "6/1/2015",
  //     "startDate": "4/25/2015",
  //     "dateFiled": "June 11, 2015",
  //     "dateFiledShort": "6/11/2015",
  //     "reportingPeriod": "4/25/2015 - 6/1/2015",
  //     "position": "Support",
  //     "city": "Brockton"
  //   },
  //   {
  //     "id": 2097,
  //     "filingEntity": "Massasoit Greyhound Association, Inc. ",
  //     "pdfFileName": "mass2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "6/1/2015",
  //     "startDate": "4/25/2015",
  //     "dateFiled": "June 11, 2015",
  //     "dateFiledShort": "6/11/2015",
  //     "reportingPeriod": "4/25/2015 - 6/1/2015",
  //     "position": "Support",
  //     "city": "Brockton"
  //   },
  //   {
  //     "id": 2098,
  //     "filingEntity": "Stand Up for Brockton",
  //     "pdfFileName": "reid2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "5/14/2015",
  //     "startDate": "5/5/2015",
  //     "dateFiled": "June 3, 2015",
  //     "dateFiledShort": "6/3/2015",
  //     "reportingPeriod": "5/5/2015 - 5/14/2015",
  //     "position": "Oppose",
  //     "city": "Brockton"
  //   },
  //   {
  //     "id": 2092,
  //     "filingEntity": "Stand UP for Brockton (amendment)",
  //     "pdfFileName": "standup2",
  //     "questionDescription": "Casino Approval",
  //     "endDate": "5/4/2015",
  //     "startDate": "1/1/2015",
  //     "dateFiled": "May 7, 2015",
  //     "dateFiledShort": "5/7/2015",
  //     "reportingPeriod": "1/1/2015 - 5/4/2015",
  //     "position": "Oppose",
  //     "city": "Brockton"
  //   }
  // ];

  const groupedByCity = reports.reduce((acc, filing: any) => {
    if (!acc[filing.city]) {
      acc[filing.city] = [];
    }
    acc[filing.city].push(filing);
    return acc;
  }, {} as Record<string, any[]>);

  const cities = Object.keys(groupedByCity);
  
  useEffect(() => {
    getCasinoBallotQuestionSpendingReports();
  }, []);

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
          variant="h5"
          align={'left'}
          data-aos={'fade-up'}
          sx={{
            fontWeight: 700,
          }}
          paddingTop={3}
          gutterBottom
          marginBottom={2}
        >
          Casino Ballot Question Spending Reports
        </Typography>
        <Divider />
        <Grid container marginTop={3} marginBottom={2}>
          <Typography marginBottom={1} sx={{ textIndent: 10 }} component={'p'} variant='body1'>Casino-related ballot question committees file their campaign finance reports on paper with their local election officials. These reports are posted on the relevant municipal websites.</Typography>
          <Typography marginBottom={1} sx={{ textIndent: 10 }} component={'p'} variant='body1'>In June 2012, state legislators considered a bill to require casino-related ballot question committees to file campaign finance reports electronically with OCPF. In the interest of providing enhanced public disclosure on a topic of increasing interest to the public, OCPF decided to ask the local election officials to forward copies of the reports filed by casino-related ballot question committees and any M22 disclosure forms filed by groups, corporations and individuals in support or opposition to these ballot questions to OCPF so that we could post them all in a centralized place.</Typography>
        </Grid>

        {
          cities.map((city) => {
            const filings = groupedByCity[city];
            const questionDescription = filings[0].questionDescription;
            return (
              <Paper sx={{padding: 2, marginBottom: 2}}>
                <Typography variant='h6'><b>{city}</b><Typography variant='subtitle2'><i>Question: {questionDescription}</i></Typography></Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{fontWeight: 'bold'}}>Date Filed</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>Name of Individual, Group or Association</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>Position</TableCell>
                        <TableCell sx={{fontWeight: 'bold'}}>Reporting Period</TableCell>
                      </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          filings.map((filing: any) => {
                            return (
                              <TableRow>
                                <TableCell><Link href={'https://ocpf2.blob.core.windows.net/pdf/reports/22s/' + filing.pdfFileName + '.pdf'} target='_blank'>{filing.filingDate} (archived report)</Link></TableCell>
                                <TableCell>{filing.filingEntity}</TableCell>
                                <TableCell>{filing.position}</TableCell>
                                <TableCell>{filing.reportStartDate + ' - ' + filing.reportEndDate}</TableCell>
                              </TableRow>
                            );
                          })
                        }
                      </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            );
          })
        }


      </Container>
    </Main>
  );
};

export default CasinoBallotQuestionSpending;